import { isFeatureApp, isContentContainerWithContent, } from '../content-types';
export function isContainerError(item) {
    return item instanceof Error;
}
export function getLoadableContentPaths(items, currentState) {
    return Array.from(new Set(items
        .filter((item) => {
        if (typeof item === 'string') {
            return needsLoading(item, currentState);
        }
        if (isFeatureApp(item) || isContentContainerWithContent(item)) {
            return false;
        }
        return needsLoading(item.contentPath, currentState);
    })
        .map((item) => (typeof item === 'string' ? item : item.contentPath))));
}
function needsLoading(contentPath, currentState) {
    const state = currentState[contentPath];
    return isContainerError(state) || state === undefined;
}
//# sourceMappingURL=utils.js.map